import React from 'react'
import FormComponent from "../components/formComponent";
import { renderReport } from "../components/elementList";

let documentation = {
    title: 'Choose Customer',
    brief: 'Choose a customer name.',
    content: 'All Acuadori customer types related to the customer are selected.'
};

class UiGetCustomer extends React.Component {

    static defaultProps = {
        error: (error) => { },
        customerTypes: [
            { name: ' Agronomist', fieldPre: 'FA ', fieldPost: ' ag', devicePre: 'DA ', devicePost: ' ag' },
            { name: ' Operator', fieldPre: 'FO ', fieldPost: ' op', devicePre: 'DO ', devicePost: ' op' }
        ],
    };

    constructor(props) {
        super(props);

        this.customerService = props.services.customer;

        this.state = {
            customerList: null,
            selectedCustomerName: '',
            finished: false
        }
    }

    documentation = () => { return documentation; }
    
    getComponentData = () => {
        let { selectedCustomerName, customerList } = this.state;

        if (!customerList) { return null; }
        else if (!customerList[selectedCustomerName]) { return null; }

        let instances = customerList[selectedCustomerName]
        let data = { name: selectedCustomerName, instances: [] };

        for (let i = 0; i < instances.length; i++) {
            let item = {
                name: instances[i].data.name,
                id: instances[i].data.id.id,
                type: instances[i].type
            };
            data.instances.push(item);
        }

        return data;
    }

    componentDidMount() {
        this.customerService.getCustomers().then(this.handleGetCustomersNext).catch(this.handleSubmitError);
    }

    handleGetCustomersNext = (response) => {
        let { customerTypes } = this.props;
        let customerList = {};
        let serverCustomers = response.data;

        for (let i = 0; i < serverCustomers.length; i++) {
            let currentCustomer = serverCustomers[i];

            for (let j = 0; j < customerTypes.length; j++) {
                let nameCheck = customerTypes[j].name;
                if (currentCustomer.name.endsWith(nameCheck)) {
                    let customerName = currentCustomer.name.substr(0, currentCustomer.name.length - nameCheck.length);
                    let customerItem = {
                        name: customerName,
                        data: currentCustomer,
                        type: customerTypes[j]
                    }
                    if (!customerList[customerName]) {
                        customerList[customerName] = [customerItem];
                    }
                    else {
                        customerList[customerName].push(customerItem);
                    }
                }
            }

        }
        this.setState({ customerList: customerList });
    };

    handleSelectCustomerNext = (response) => {
        let { customerList } = this.state;

        if (!customerList[response.customer]) {
            this.handleSubmitError('Inhexistent customer, please choose one!');
        }
        else {
            this.setState(
                {
                    finished: true,
                    selectedCustomerName: response.customer
                },
                () => this.props.finished(this.getComponentData(), this.reportAllComponentData())
            );
        }
    };

    handleSubmitError = (error) => {
        let message = 'Error: ' + error.message;
        this.renderAlert(message, 'warning');
        if (this.props.error) {
            this.props.error(error);
        }
    };

    renderAlert = (message, variant) => {
        this.setState({ messageAlert: message, variantAlert: variant, showAlert: true });
    };

    renderSelectCustomer = () => {
        let { customerList } = this.state;
        let elements = !!customerList ? Object.keys(customerList).map(customerName => {
            return { value: customerName, label: customerName }
        }) : null;

        let formElement = [
            {
                key: 'customer', type: 'select', inputType: 'select', placeholder: 'Select the Customer that owns the field',
                value: '', label: 'Customer', options: elements
            },
        ];

        return (
            <div>
                {!!customerList && <FormComponent
                    initialValues={{ name: '', description: '' }}
                    validateFunc={(values) => {
                        const errors = {};
                        if (!values.customer) {
                            errors.customer = 'Required';
                        }
                        return errors;
                    }}
                    submitFunc={this.handleSelectCustomerNext}
                    inputs={formElement}
                />}
            </div>
        );
    };


    reportAllComponentData = () => {
        let customer = this.getComponentData();


        let data = { 'Customer': customer.name };
        for (let i = 0; i < customer.instances.length; i++) {
            data[`Customer ${customer.instances[i].type.name} Name`] = customer.instances[i].name;
            data[`Customer ${customer.instances[i].type.name} ID`] = customer.instances[i].id;
        }

        return data;
    }

    render() {
        let { finished } = this.state;
        return (
            <div className="container-fluid">
                <div className="m-4 p-4">
                    {!finished && this.renderSelectCustomer()}
                    {finished && renderReport(this.reportAllComponentData())}
                </div>
            </div>);
    }
}


export default UiGetCustomer;
export {
    UiGetCustomer,
    documentation
}